import React from "react";
import styles from "./style.module.css";

import { LineInput } from "components/Inputs/LineInput";
import { Button, ButtonGroup } from "aible";

import awsIcon from "images/logo-aws.svg";
import azureIcon from "images/logo-azure.svg";

class AccountTypeIcon extends React.PureComponent {
  render() {
    const { type, hide } = this.props;
    return (
      <div className={styles.accountTypeIcon + (hide ? " " + styles.accountTypeIconHide : "")}>
        <img src={type === "azure" ? azureIcon : awsIcon} alt={type} />
        {type === "azure" ? "Azure" : "Amazon"}
      </div>
    );
  }
}

export class AddAccount extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isAzure: false,
      name: "",
      accountId: "",
      subscriptionID: "",
      groupID: "",
      launchCode: ""
    };
  }

  handleCreate(name, id) {
    const { handleCreateAWSAccount } = this.props;
    this.setState({ isCreating: false });
    return handleCreateAWSAccount(name, id);
  }

  handleAzureCreate(name, subscriptionID, groupID, launchCode) {
    const { handleCreateAzureAccount } = this.props;

    const runURL = "https://" + groupID + ".azurewebsites.net/api/launchfunc?code=" + encodeURIComponent(launchCode);
    // AuthURL is no longer required, leaving placeholder in order to minimize backend changes
    const authURL = runURL;
    const config = {
      subscriptionID,
      authURL,
      runURL
    };
    this.setState({ isCreating: false });
    return handleCreateAzureAccount(name, config);
  }

  render() {
    const { accountId, isAzure, subscriptionID, groupID, launchCode, name } = this.state;
    const { hidden, setShowAddAccount } = this.props;
    const addAccountClass = styles.addAccount + " " + (hidden ? styles.hide : "");

    return (
      <div className={addAccountClass}>
        <ButtonGroup className={styles.buttonGroup}>
          <Button active={!isAzure} onClick={() => this.setState({ isAzure: false })}>
            <AccountTypeIcon type="aws" />
          </Button>
          <Button active={isAzure} onClick={() => this.setState({ isAzure: true })}>
            <AccountTypeIcon type="azure" />
          </Button>
        </ButtonGroup>
        <div className={styles.iLabel}>{"Account Nickname:"}</div>
        <LineInput
          isBox
          ref="name"
          value={name}
          className={styles.input}
          updateInstant
          onChange={(val) => this.setState({ name: val })}
        />
        {isAzure ? (
          <React.Fragment>
            <div className={styles.iLabel}>{"Azure Subscription ID:"}</div>
            <LineInput
              isBox
              ref="subscriptionID"
              value={subscriptionID}
              className={styles.input}
              updateInstant
              onChange={(val) => this.setState({ subscriptionID: val })}
            />
            <div className={styles.iLabel}>{"Azure Group ID:"}</div>
            <LineInput
              isBox
              ref="groupID"
              value={groupID}
              className={styles.input}
              updateInstant
              onChange={(val) => this.setState({ groupID: val })}
            />
            <div className={styles.iLabel}>{"API Host Key:"}</div>
            <LineInput
              isBox
              ref="launchCode"
              value={launchCode}
              className={styles.input}
              updateInstant
              onChange={(val) => this.setState({ launchCode: val })}
            />
          </React.Fragment>
        ) : (
          <div>
            <div className={styles.iLabel}>{"AWS Account ID:"}</div>
            <LineInput
              isBox
              ref="accountId"
              value={accountId}
              className={styles.input}
              updateInstant
              onChange={(val) => this.setState({ accountId: val })}
            />
          </div>
        )}
        <div className={styles.fRight}>
          <Button type="secondary" style={{ marginRight: "10px" }} onClick={() => setShowAddAccount(false)}>
            {"Cancel"}
          </Button>
          <Button
            type="primary"
            disabled={
              name === "" ||
              (accountId === "" && !isAzure) ||
              ((subscriptionID === "" || groupID === "" || launchCode === "") && isAzure)
            }
            onClick={
              isAzure
                ? () => this.handleAzureCreate(name, subscriptionID, groupID, launchCode)
                : () => this.handleCreate(name, accountId)
            }
          >
            {"Create"}
          </Button>
        </div>
      </div>
    );
  }
}

export default AddAccount;
